import { createSelector } from 'reselect'

export const getCartHistoryPaginationParams = createSelector(
  (state) => state && state.cart && state.cart.history && state.cart.history.pagination,
  pagination => pagination
)
